import React from 'react';
import Navbar from './Navigation/Navbar';
import Footer from './Components/Footer';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import Games from './Navigation/Games';

import SpinWheels from './Navigation/SpinWheels';
import NumberWheel from './Wheels/NumberWheel.js';
import TruthOrDareWheel from './Wheels/TruthOrDareWheel';
import MonthWheel from './Wheels/MonthWheel'
import Contact from './Navigation/Contact';
import Guess from './Guess/GuessLevelOne';
import SnakeBoard from './Snake/SnakeBoard';
import CharCounter from './Tools/CharCounter/CharCounter.js';
import GreetingCards from './Tools/GreetingCards/GreetingCards.js';

// Legal and Help Pages
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsOfService from './Pages/TermsOfService';
import About from './Pages/About';
import HelpFAQ from './Pages/HelpFAQ';

import './App.css';
import TigerPuzzle from './Games/ArrangePuzzle/TigerPuzzle.js';
import Tools from './Navigation/Tools.js';
import LionsPuzzle from './Games/ArrangePuzzle/LionsPuzzle.js';
import CountryQuizGame from './Games/Quiz/CountryQuizGame.js';
import GemQuest from './Games/GemQuest/GemQuest.js';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // Scroll to top immediately when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use instant instead of smooth for immediate scroll
    });
  }, [pathname]);

  return null;
}

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <div className="main-content">
          <Switch>
            <Route exact path="/" component={Games} />
            <Route exact path="/tools" component={Tools} />
            <Route exact path="/spin-wheels" component={SpinWheels} />
            <Route exact path="/spin-wheels/number-spinner" component={NumberWheel} />
            <Route exact path="/spin-wheels/truth-or-dare-spinner" component={TruthOrDareWheel} />
            <Route exact path="/spin-wheels/month-spinner" component={MonthWheel} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/guess-secret-number" component={Guess} />
            <Route exact path="/snake-game" component={SnakeBoard} />
            <Route exact path="/tiger-image-shuffle-game" component={TigerPuzzle} />
            <Route exact path="/lions-image-shuffle-game" component={LionsPuzzle} />
            <Route exact path="/country-quiz" component={CountryQuizGame} />
            <Route exact path="/gem-quest" component={GemQuest} />
            <Route exact path="/character-counter" component={CharCounter} />
            <Route exact path="/greeting-cards" component={GreetingCards} />
            
            {/* Legal and Help Pages */}
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route exact path="/terms-of-service" component={TermsOfService} />
            <Route exact path="/about" component={About} />
            <Route exact path="/help" component={HelpFAQ} />

          </Switch>
        </div>
        <Footer />
      </BrowserRouter>
    );
  }
}
export default App;